export default __webpack_public_path__ + "static/media/mastercard.27fca3e7.png";